<template>
<v-app>
  <v-row>
    <v-col cols="24" lg="20" offset-lg="2">
    <contact-form :name="name" :required-fields="requiredFields">
      <h2>I. Ihre Daten</h2>
      <div class="row">
        <div class="col-sm-8">
          <contact-select name="salutation" label="Anrede" values="Frau,Herr" placeholder="Anrede"></contact-select>
        </div>
        <div class="col-sm-8">
          <contact-input name="firstname" label="Vorname"></contact-input>
        </div>
        <div class="col-sm-8">
          <contact-input name="lastname" label="Nachname"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8">
          <contact-input name="street" label="Straße"></contact-input>
        </div>
        <div class="col-sm-8">
          <contact-input name="zip" label="PLZ/Ort"></contact-input>
        </div>
        <div class="col-sm-8">
          <contact-input name="phone" label="Telefonnummer"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <contact-input name="mobil" label="Mobilnummer"></contact-input>
        </div>

        <div class="col-sm-12">
          <contact-input name="email" label="E-Mail"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <contact-select name="rechtschutz" label="Sind Sie rechtsschutzversichert?" values="Nein,Ja" placeholder="Sind Sie rechtsschutzversichert?"></contact-select>
        </div>

        <div class="col-sm-12">
          <contact-input name="rechtSchutzDaten" label="Wenn ja: Versicherung und Vers.-Nr.?"></contact-input>
        </div>
      </div>

      <h2>II. Ihr Fahrzeug</h2>

      <div class="row">
        <div class="col-sm-8">
          <contact-input name="perKennzeichen" label="Ihr amtliches Kennzeichen"></contact-input>
        </div>
        <div class="col-sm-8">
          <contact-input name="perKFZMarkeTyp" label="KFZ-Marke/Typ"></contact-input>
        </div>
        <div class="col-sm-8">
          <contact-select name="perEigentümer" label="Sind Sie Eigentümer des KFZ?" values="Nein,Ja" placeholder="Sind Sie Eigentümer des KFZ?"></contact-select>
        </div>
      </div>

      <div class="row">
        <div class="col-24">
          <contact-input  textarea label="Falls nein, Name, Anschrift u. Tel. des Eigentümers" name="perAnschrift"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <contact-select name="perLeasing" label="Ist das KFZ geleast?" values="Nein,Ja" placeholder="Ist das KFZ geleast?"></contact-select>
        </div>

        <div class="col-sm-12">
          <contact-select name="perFinanziert" label="Ist das KFZ finanziert?" values="Nein,Ja" placeholder="Ist das KFZ finanziert?"></contact-select>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <contact-select name="perVollkasko" label="Ist das KFZ vollkaskoversichert?" values="Nein,Ja" placeholder="Ist das KFZ vollkaskoversichert?"></contact-select>
        </div>

        <div class="col-sm-12">
          <contact-select name="perVollKaskoAnspruch" label="Wenn ja, soll die Vollkaskoversicherung in Anspruch genommen werden?" values="Nein,Ja" placeholder="Wenn ja, soll die Vollkaskoversicherung in Anspruch genommen werden?"></contact-select>
        </div>
      </div>

      <h2>III. Gegnerisches Fahrzeug</h2>

      <div class="row">
        <div class="col-sm-12">
          <contact-input name="gegKennzeichen" label="Ihr amtliches Kennzeichen"></contact-input>
        </div>
        <div class="col-sm-12">
          <contact-input name="gegKFZMarkeTyp" label="KFZ-Marke/Typ"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-24">
          <contact-input  textarea label="Falls nein, Name, Anschrift u. Tel. des Eigentümers" name="gegAnschrift"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8">
          <contact-input name="gegHaftpflich" label="Gegnerische Haftpflichtversicherung"></contact-input>
        </div>

        <div class="col-sm-8">
          <contact-input name="gegVersicherungsnummer" label="Versicherungsscheinnummer"></contact-input>
        </div>

        <div class="col-sm-8">
          <contact-input name="gegSchadennummer" label="Dortige Schadennummer"></contact-input>
        </div>
      </div>

      <h2>IV. Unfallereignis</h2>

      <div class="row">
        <div class="col-sm-8">
          <contact-input name="unfallort" label="Unfallort"></contact-input>
        </div>
        <div class="col-sm-8">
          <contact-input name="unfallzeit" label="Unfallzeit"></contact-input>
        </div>
        <div class="col-sm-8">
          <contact-select name="unfallPolizeilich" label="Unfall polizeilich aufgenommen" values="Nein,Ja" placeholder="Unfall polizeilich aufgenommen"></contact-select>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <contact-input name="polizeiVorgangsnummer" label="Wenn ja, Polizeidienststelle, Vorgangsnummer"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <contact-input  textarea label="Unfallzeugen (Name, Anschrift)" name="unfallzeugen"></contact-input>
        </div>

        <div class="col-sm-12">
          <contact-input  textarea label="Kurze Unfallschilderung" name="unfallschilderung"></contact-input>
        </div>
      </div>

      <h2>V. Schaden am Fahrzeug</h2>

      <div class="row">
        <div class="col-sm-8">
          <contact-select name="sachverständiger" label="Begutachtung durch Sachverständigen erfolgt?" values="Nein,Ja" placeholder="Begutachtung durch Sachverständigen erfolgt?"></contact-select>
        </div>

        <div class="col-sm-8">
          <contact-select name="fahrbereit" label="Fahrzeug nach Unfall fahrbereit?" values="Nein,Ja" placeholder="Fahrzeug nach Unfall fahrbereit?"></contact-select>
        </div>

        <div class="col-sm-8">
          <contact-select name="mietwagen" label="Wenn Nein: Nehmen Sie einen Mietwagen in Anspruch oder möchten Sie dies tun?" values="Nein (in diesem Fall kann Nutzungsausfall geltend gemacht werden),Ja (bitte Mietwagenrechnung zur Akte reichen)" placeholder="Wenn Nein: Nehmen Sie einen Mietwagen in Anspruch oder möchten Sie dies tun?"></contact-select>
        </div>
      </div>

      <h2>VI. Personenschäden</h2>
      <div class="row">
        <div class="col-sm-8">
          <contact-select name="verletzt" label="Wurden Sie verletzt?" values="Nein,Ja" placeholder="Wurden Sie verletzt?"></contact-select>
        </div>

        <div class="col-sm-8">
          <contact-select name="weitereVerletzte" label="Gab es weitere Verletzte" values="Nein,Ja" placeholder="Gab es weitere Verletzte"></contact-select>
        </div>

        <div class="col-sm-8">
          <contact-input textarea label="Falls ja, Name, Anschrift, Tel." name="anschriftVerletzten"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8">
          <contact-input name="umfangVerletzung" label="Art und Umfang Ihrer Verletzung"></contact-input>
        </div>

        <div class="col-sm-8">
          <contact-select name="krankenhaus" label="Hatten Sie einen Krankenhausaufenthalt?" values="Nein,Ja" placeholder="Hatten Sie einen Krankenhausaufenthalt?"></contact-select>
        </div>

        <div class="col-sm-8">
          <contact-input name="krankenhausVon" label="Wenn ja, von"></contact-input>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8">
          <contact-input name="krankenhausBis" label="bis"></contact-input>
        </div>

        <div class="col-sm-8">
          <contact-input name="krankenhausAnschrift" label="Namen und Anschrift des Krankenhauses"></contact-input>
        </div>

        <div class="col-sm-8">
          <contact-input name="aerzte" label="Ambulant behandelnde Ärzte"></contact-input>
        </div>
      </div>

      <contact-checkbox name="kostenrechtsmodernisierungsgesetzes" label="Seit Inkrafttreten des Kostenrechtsmodernisierungsgesetzes sind wir verpflichtet, ab dem 01.07.2004 nach § 49 b Abs. 5 BRAO vor Übernahme des Mandates darauf hinzuweisen, dass sich die zu erhebenden Gebühren nach dem Gegenstandswert richten. Die Daten werden zur Bearbeitung des Mandates elektronisch verarbeitet und gespeichert"></contact-checkbox>

    </contact-form>
    </v-col>
  </v-row>
</v-app>
</template>

<script>
import ContactForm from "./ContactForm";
import ContactInput from "./ContactInput.vue";
import ContactSelect from "./ContactSelect.vue";
import ContactCheckbox from "./ContactCheckbox.vue";

export default {
  name: "Verkehrsunfall",

  components: {
    ContactForm,
    ContactInput,
    ContactSelect,
    ContactCheckbox
  },

  data() {
    return {
      name: "verkehrsunfall"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    },

    exclude() {
      if (this.$root.exclude) {
        return this.$root.exclude;
      }

      return [];
    }
  }
};
</script>
